export const STATUS_OK = 200;
export const STATUS_CREATED = 201;
export const STATUS_NO_CONTENT = 204;
export const STATUS_PARTIAL_CONTENT = 206;
export const STATUS_FOUND = 302;
export const STATUS_SEE_OTHER = 303;
export const STATUS_BAD_REQUEST = 400;
export const STATUS_UNAUTHORIZED = 401;
export const STATUS_FORBIDDEN = 403;
export const STATUS_NOT_FOUND = 404;
export const STATUS_NOT_ACCEPTABLE = 406;
export const STATUS_CONFLICT = 409;
export const STATUS_GONE = 410;
export const STATUS_UNPROCESSABLE_ENTITY = 422;
export const STATUS_TOO_MANY_REQUESTS = 429;
export const STATUS_INTERNAL_SERVER_ERROR = 500;
export const STATUS_NOT_IMPLEMENTED = 501;

export const HEADER_ACCESS_CONTROL_ALLOW_ORIGIN = 'Access-Control-Allow-Origin';
export const HEADER_ACCESS_CONTROL_ALLOW_METHODS =
  'Access-Control-Allow-Methods';
export const HEADER_ACCESS_CONTROL_ALLOW_HEADERS =
  'Access-Control-Allow-Headers';
export const HEADER_ACCEPT = 'Accept';
export const HEADER_ACCEPT_RANGES = 'Accept-Ranges';
export const HEADER_CACHE_CONTROL = 'Cache-Control';
export const HEADER_CONTENT_DISPOSITION = 'Content-Disposition';
export const HEADER_CONTENT_ENCODING = 'Content-Encoding';
export const HEADER_CONTENT_LENGTH = 'Content-Length';
export const HEADER_CONTENT_RANGE = 'Content-Range';
export const HEADER_CONTENT_SECURITY_POLICY = 'Content-Security-Policy';
export const HEADER_CONTENT_TYPE = 'Content-Type';
export const HEADER_COOKIE = 'Cookie';
export const HEADER_CSP = 'Content-Security-Policy';
export const HEADER_ETAG = 'ETag';
export const HEADER_EXPIRES = 'Expires';
export const HEADER_LAST_MODIFIED = 'Last-Modified';
export const HEADER_ORIGIN = 'Origin';
export const HEADER_PRAGMA = 'Pragma';
export const HEADER_RANGE = 'Range';
export const HEADER_REFERER = 'Referer';
export const HEADER_STRICT_TRANSPORT_SECURITY = 'Strict-Transport-Security';
export const HEADER_USER_AGENT = 'User-Agent';
export const HEADER_WEBKIT_CSP = 'X-WebKit-CSP';
export const HEADER_X_CSP = 'X-Content-Security-Policy';
export const HEADER_X_FORWARDED_PROTO = 'X-Forwarded-Proto';
export const HEADER_X_FRAME_OPTIONS = 'X-Frame-Options';

export const HEADER_APOLLO_GRAPHQL_CLIENT_NAME = 'apollographql-client-name';
export const HEADER_SEGMENT_ANONYMOUS_ID = 'segment-anonymous-id';
